import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

/**
 * Inline CTA that replaces the old Phase-7 Smart Match tabs (UploadJdTab,
 * BulkJdTab, BulkResumeTab, MatchesTab) wherever they were mounted inside
 * other pages' modals or sub-tabs. Post-image-review (Apr 2026): the new
 * four-stage canvas at /smart-match/new is the single entry point.
 */
interface Props {
  title?: string;
  subtitle?: string;
  ctaLabel?: string;
}

export function SmartMatchRedirectCTA({
  title = 'Smart Match has moved',
  subtitle = 'Upload JDs, bulk resumes and matches now live on the Smart Match canvas — a single four-stage flow with AI reasoning in the middle.',
  ctaLabel = 'Open Smart Match',
}: Props) {
  return (
    <div
      className="ggj-card flex flex-col items-center gap-4 rounded-[10px] border px-6 py-10 text-center"
      style={{
        borderColor: 'var(--vscode-border-primary)',
        background: 'var(--vscode-bg-primary)',
      }}
    >
      <span
        className="flex h-10 w-10 items-center justify-center rounded-full"
        style={{ background: 'color-mix(in srgb, var(--ggj-accent) 14%, transparent)' }}
      >
        <Sparkles className="h-5 w-5" style={{ color: 'var(--ggj-accent)' }} aria-hidden />
      </span>
      <div className="max-w-md space-y-1">
        <p className="ggj-text-lead font-semibold" style={{ color: 'var(--vscode-text-primary)' }}>
          {title}
        </p>
        <p className="ggj-text-body" style={{ color: 'var(--vscode-text-secondary)' }}>
          {subtitle}
        </p>
      </div>
      <Link
        to="/smart-match/new"
        className="inline-flex items-center gap-1.5 rounded-[10px] px-3 py-2 ggj-text-meta font-medium transition-colors"
        style={{
          background: 'var(--ggj-accent)',
          color: 'white',
        }}
      >
        {ctaLabel}
        <ArrowRight className="h-3.5 w-3.5" aria-hidden />
      </Link>
    </div>
  );
}
